import React, { useState,  useEffect } from "react";
import TableHeader from "../../common/table/TableHeader";
import TableSkeleton from "../../common/table/TableSkeleton";
import ViewKYC from "./ViewKYC";
import useShowAlert from "../../../utils/AlertUtiles";
import DateConverter from "@heartinz/date_and_time_processor";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import axiosInstance from "../../../utils/AxiosInstance";
import uRLs from "../../../utils/baseUtils";
import handleError from "../../../constant/handleError";
import ReactPaginate from "react-paginate";
import { capitalizeFirstLetter } from "../../../utils/helper";

function KYCManagement() {
  const [kycList, setKycList] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [loading, setLoading] = useState({
      list: false,
      update:null
    });
  const [isSelectedData, setSelectedData] = useState({});
  const [isViewModelOpen, setViewModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);  
  const showAlert = useShowAlert();   
  

   const handleApprove = async (partnerId) => {
    try {
      setLoading((prev) => ({ ...prev, update: partnerId }));

      const response = await axiosInstance.patch(`partnerkyc/admin/${partnerId}`);
      if (response?.data?.status) {
        showAlert("success",response?.data?.message );

   const updatedKycItem = response.data.results; 
            setKycList((prevData) => {               
                if (activeTab === "Review") {
                  setTotalItems(prev => prev - 1);
                    return prevData.filter(p => p.partnerId !== partnerId);
                } else {                    
                    return prevData.map((p) =>
                        p.partnerId === partnerId 
                            ? {                          
                                  ...p,                                 
                                  ...updatedKycItem,                                
                                  isApproved: true,
                                  status: "APPROVED",
                              }
                            : p
                    );
                }
            });
          setSelectedData(prevData => ({
                ...prevData,
                ...updatedKycItem,
                isApproved: true,
                status: "APPROVED",
            }));
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, update: false }));
    }
  };
 
  const allHeaders = [
      "S.No",
      "Date",
      "Partner Name", 
      "UPI / A/C No" ,  
      "Status" ,
      // "Action"  
    ];

const headers = activeTab === "All"
  ? allHeaders
  : allHeaders.filter(header => header !== "Status");

 const tabs = ["All", "Approved", "Review","Drafts",];

 const handleViewKYC = async (item) => {    
      setSelectedData(item);
      setViewModalOpen(true);
  
  };

 const handleCloseKYC = async () => {
    setViewModalOpen(false);
          setSelectedData(null);
  };

 const fetchKYC = async (page = 0, tab = activeTab) => {
        setLoading((prev) => ({ ...prev, list: true }));
        checkNetworkStatus();

    try {
      let endpoint = "";
      if (tab === "Approved") endpoint = `partnerkyc/admin/status?status=APPROVED&pageno=${page + 1}&limit=${uRLs.PER_PAGE}`;
      else if (tab === "Review") endpoint = `partnerkyc/admin/status?status=SUBMITTED&pageno=${page + 1}&limit=${uRLs.PER_PAGE}`;
      else if (tab === "Drafts")  endpoint = `partnerkyc/admin/status?status=PENDING&pageno=${page + 1}&limit=${uRLs.PER_PAGE}`;
      else endpoint = `partnerkyc/admin/?pageno=${page + 1}&limit=${uRLs.PER_PAGE}`;
       const response = await axiosInstance.get(endpoint);
      if (
        response &&
        response?.data?.status &&
        response?.data?.results?.length > 0
      ) {

        setKycList(response.data.results);
      }
      else{
        setKycList([])
      }
      if (response?.data?.results?.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response?.data.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      setKycList([]);
      setTotalPages(0);
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, list: false }));
    }
  };

 useEffect(() => {
    fetchKYC (currentPage,activeTab);
  }, [currentPage,activeTab]);

  return (
    <>
     <div className=" pe-3">
        <div class="breadcrumb-title pe-3 mb-2"> Partner KYC Review</div>
      </div>

      <div className="mb-3">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() =>{if (activeTab !== tab) {
                    setCurrentPage(0); 
                } setActiveTab(tab)}}
            className=" me-1 cursor-poInter"
            style={{
              padding: "10px 15px",
              border: "none",
              fontWeight: activeTab === tab ? "bold" : "normal",
              borderBottom:
                activeTab === tab ? "2px solid blue" : "2px solid transparent",
              backgroundColor: "transparent",
            }}
          >
            {tab}
          
          </button>
        ))}
      </div>

    
       <div className="col-col-12 ">
        <div className="card mb-0">
          <div className="card-body p-0">
          <table className="table align-middle table-hover mb-0 cursor-pointer ">
             <TableHeader headers={headers} />           
            <tbody>
              {loading.list ? (
                  <TableSkeleton
                    rows={5}
                 columns={activeTab === "All" 
        ? [300, 200, 200, 200, 200,] 
        : [300, 200, 200, 200,  ] 
    }
                  />
                ) : Array.isArray(kycList) &&
              kycList.length > 0 ? (
                kycList.map((kyc, index) => (
                  <tr key={kyc._id}   onClick={() => {
                                handleViewKYC(kyc);
                              }} >
                    <td className="text-center">{totalItems - (currentPage * uRLs.PER_PAGE + index)}</td>  
                     <td className="text-center">  { DateConverter.ISOToDisplayFormat(
                          DateConverter.convertToTimeZone(kyc?.createdAt, uRLs.TIMEZONE)
                        ).date}</td>             
                    <td className="text-center">{capitalizeFirstLetter(kyc?.fullName)}</td>                    
                  
                                            
                    <td className="text-center">
                  <div className="font-13">{kyc.upiId}</div>
                  <div className="font-12 text-muted">
                     {capitalizeFirstLetter(kyc.bankDetails?.accountNumber) }
                  </div>
                </td>
                  {activeTab === "All" && (
                    <td className="text-center">
                      {kyc?.status === "SUBMITTED" ? (
                       <span className="app-badge bg-label-moon ">
                            Submitted
                        </span>
                         ): kyc?.status === "APPROVED" ? (
                        <span className="app-badge bg-label-spring ">
                            Approved
                        </span>
                    ) : kyc?.status === "PENDING" ? (
                        <span className="app-badge bg-light text-black ">
                            Draft
                        </span>
                    ) : (
                       <span className="app-badge bg-secondary">
                     {kyc?.status || 'No Status'}
                   </span>
                      )}
                    </td>
                )}
                     {/* <td className="text-center">
                          <div className=" d-flex justify-content-center order-actions">
                            <button
                              type="button"
                              className="btn-label-primary shadow-none me-2"
                              onClick={() => {
                                handleViewKYC(kyc);
                              }}
                            >
                              <i className="lni lni-eye"></i>
                            </button>
                          </div>
                        </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="text-center py-3 text-muted">
                    No records found in this list.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
           {totalPages > 0 &&  (
                        <div className="d-flex justify-content-center mt-3">
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            breakLabel={"..."}
                            onPageChange={({ selected }) => {
                              setLoading((prev) => ({ ...prev, list: true }));
                              setCurrentPage(selected);
                            }}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            activeClassName="active"
                            forcePage={currentPage}
                          />
                        </div>
            )}        
      </div>
      {isViewModelOpen && (
                <ViewKYC
                  onClose={handleCloseKYC}
                  isData={isSelectedData}
                  onApprove={handleApprove}         
                  loading={loading}        
                />
              )}
     </div>  
    </>
  );
}

export default KYCManagement;

